import queryString from 'query-string';

import { AttributionData } from '../interfaces';

export function mapAttribution(attribution: AttributionData) {
  const search = queryString.parse(window.location.search);

  let p: {
    pid?: string,
    c?: string,
    af_c_id?: string,
    af_adset?: string,
    af_adset_id?: string,
    af_ad?: string,
    af_ad_id?: string,
    af_pmod_priority?: 'equal',
    af_r?: string,
    af_ios_url?: string,
    af_android_url?: string,
    af_web_dp?: string,
  } = {
    pid: attribution.source || undefined,
    c: attribution.c || undefined,
    af_c_id: attribution.c_id || undefined,
    af_adset: attribution.adset || undefined,
    af_adset_id: attribution.adset_id || undefined,
    af_ad: attribution.ad || undefined,
    af_ad_id: attribution.ad_id || undefined,
    af_pmod_priority: 'equal',
  };

  if (search.af_r) {
    p.af_r = String(search.af_r);
  }
  if (search.af_ios_url) {
    p.af_ios_url = String(search.af_ios_url);
  }
  if (search.af_android_url) {
    p.af_android_url = String(search.af_android_url);
  }
  if (search.af_web_dp) {
    p.af_web_dp = String(search.af_web_dp);
  }

  return p;
}
